import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

import {map} from 'rxjs/operators';

import {APP_CONFIG} from 'src/app/shared/common/config';
import {MapUtils} from '../../shared/utils/mapper';
import {User} from 'src/app/models/user.model';
import {UserGroup} from 'src/app/models/user-group.model';
import {FXResponse} from 'src/app/models/response.model';

@Injectable()
export class UserSettingsService {
  constructor(private http: HttpClient) {}

  serializeUser(user: User): any {
    return MapUtils.serialize(user);
  }

  getUsers(): Observable<FXResponse<User[]>> {
    return this.http.get(`${APP_CONFIG.BASE_API_LINK.USER_SETTING}/users`).pipe(
      map((res: any) => {
        const data = res.data.users;
        const response = new FXResponse<User[]>().deserialize(res);
        const users = data.map((user: any) =>
          MapUtils.deserialize(User, user)
        );
        response.data = users;
        return response;
      })
    );
    /*return new Observable<FXResponse<User[]>>((observer) => {
      const res: any = DUMMY_DATA.USER_SETTINGS.USERS;
      observer.next(res);
      observer.complete();
    }).pipe(
      map((res: any) => {
        const data = res.data.users;
        const response = new FXResponse<User[]>().deserialize(res);
        const users = data.map((user: any) => MapUtils.deserialize(User, user));
        response.data = users;
        return response;
      })
    );*/
  }

  create(user: User): Observable<any> {
    const jsonUser = MapUtils.serialize(user);
    return this.http
      .post(`${APP_CONFIG.BASE_API_LINK.USER_SETTING}/users`, jsonUser)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  update(user: User): Observable<any> {
    const jsonUser = MapUtils.serialize(user);
    return this.http
      .patch(`${APP_CONFIG.BASE_API_LINK.USER_SETTING}/users`, jsonUser)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  delete(ids: number[]): Observable<FXResponse<any>> {
    return this.http
      .request('delete', `${APP_CONFIG.BASE_API_LINK.USER_SETTING}/${ids[0]}`, {
        body: { id: ids },
      })
      .pipe(
        map((res: any) => {
          return new FXResponse<any>().deserialize(res);
        })
      );
  }

  getGroups(): Observable<FXResponse<UserGroup[]>> {
    return this.http
      .get(`${APP_CONFIG.BASE_API_LINK.USER_SETTING}/groups`)
      .pipe(
        map((res: any) => {
          const data = res.data.groups;
          const response = new FXResponse<UserGroup[]>().deserialize(res);
          const groups = data.map((group: any) => {
            return MapUtils.deserialize(UserGroup, group);
          });
          response.data = groups;
          return response;
        })
      );
    /*return new Observable<FXResponse<UserGroup[]>>((observer) => {
      const res: any = DUMMY_DATA.USER_SETTINGS.GROUPS;
      observer.next(res);
      observer.complete();
    }).pipe(
      map((res: any) => {
        const data = res.data.groups;
        const response = new FXResponse<UserGroup[]>().deserialize(res);
        const groups = data.map((group: any) => {
          return MapUtils.deserialize(UserGroup, group);
        });
        response.data = groups;
        return response;
      })
    );*/
  }

  createGroup(group: UserGroup): Observable<any> {
    const jsonGroup: any = MapUtils.serialize(group);
    return this.http
      .post(`${APP_CONFIG.BASE_API_LINK.USER_SETTING}/groups`, jsonGroup)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  updateGroup(group: UserGroup): Observable<any> {
    const jsonGroup: any = MapUtils.serialize(group);
    return this.http
      .put(`${APP_CONFIG.BASE_API_LINK.USER_SETTING}/groups`, jsonGroup)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  deleteGroup(ids: number[]): Observable<any> {
    return this.http
      .request(
        'delete',
        `${APP_CONFIG.BASE_API_LINK.USER_SETTING}/groups/${ids[0]}`,
        {
          body: { id: ids },
        }
      )
      .pipe(
        map((res: any) => {
          return new FXResponse<any>().deserialize(res);
        })
      );
  }
}
